import './style.scss';

const getInitials = (fname, lname) => {
  if (fname && !lname) {
    return fname[0] + fname[1];
  } else if (!fname && lname) {
    return lname[0] + lname[1];
  } else {
    return fname[0] + lname[0];
  }
};

const Avatar = ({ fname, lname, className }) => {
  return (
    <div className={`avatar-circle ${className ? className : ''}`}>
      <div className="m-auto">{getInitials(fname, lname)}</div>
    </div>
  );
};

export default Avatar;
